import Builder from 'builder-pattern';
import { SystemFolder } from 'commons/constants/KeyFlowConstants';

export class LowresRelativeURLBuilder {
  private folderName = SystemFolder.LOWRES_FOLDER_NAME;
  private _categoryId = -1;
  private _fileName = '';

  categoryId(categoryId: number) {
    this._categoryId = categoryId;

    return this;
  }

  fileName(fileName: string) {
    this._fileName = fileName;
    return this;
  }

  build() {
    return `${this.folderName}/${this._categoryId}/${this._fileName}`;
  }
}
export class ThumbnailRelativeURLBuilder {
  private folderName = SystemFolder.THUMBNAIL_FOLDER_NAME;
  private _categoryId = -1;
  private _fileName = '';

  categoryId(categoryId: number) {
    this._categoryId = categoryId;

    return this;
  }

  fileName(fileName: string) {
    this._fileName = fileName;
    return this;
  }

  build() {
    return `${this.folderName}/${this._categoryId}/${this._fileName}`;
  }
}

export class ScriptThumbnailRelativeURLBuilder {
  private folderName = SystemFolder.SCRIPT_FOLDER_NAME;
  private _categoryId = -1;
  private _refId = -1;
  private _fileName = '';

  categoryId(categoryId: number) {
    this._categoryId = categoryId;

    return this;
  }

  refId(refId: number) {
    this._refId = refId;
    return this;
  }

  fileName(fileName: string) {
    this._fileName = fileName;
    return this;
  }

  build() {
    return `${this.folderName}/${this._categoryId}/${this._refId}/${this._fileName}`;
    // return `${SystemFolder.SCRIPT_FOLDER_NAME}/${this.categoryId}/${this.refId}/${this.thumbnailPath}`;
  }
}

export class SkimRelativeURLBuilder {
  private folderName = SystemFolder.SKIM_FOLDER_NAME;
  private _categoryId = -1;
  private _fileName = '';

  categoryId(categoryId: number) {
    this._categoryId = categoryId;

    return this;
  }

  fileName(fileName: string) {
    this._fileName = fileName;
    return this;
  }

  build() {
    return `${this.folderName}/${this._categoryId}/${this._fileName}`;
    // `${SystemFolder.SKIM_FOLDER_NAME}/${this.categoryId}/${this.skimPath}`;
  }
}
